"use strict";
var FieldContext = (function () {
    function FieldContext(fieldOptions) {
        this.fieldOptions = fieldOptions;
    }
    return FieldContext;
}());
exports.FieldContext = FieldContext;
//# sourceMappingURL=FieldContext.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/searchkit/lib/src/core/query/field_context/FieldContext.js
// module id = 77
// module chunks = 0